import { TProjectEditorState } from 'shared/reducers';

export const selectLoading = (state: TProjectEditorState) => state.loader;
